import React,{useState,useEffect} from 'react'
import SubHeader from '../../layout/components/SubHeader'
import { useEyeconxStore } from '../../../store/eyeconxStore'
import PatientList from './PatientList'
import PatientHeader from './PatientHeader'
import Pagination2 from '../../common/Pagination2'
function PatientFiles() {
  const todaysAppointment = useEyeconxStore(state => state.todaysAppointment)
  const [patientList,setPatientList] = useState(todaysAppointment)
  const [pageNo,setPageNo] = useState(1)
  const [pageSize,setPageSize] = useState(10)
  const [totalPages,setTotalPages] = useState(1)


  useEffect(()=>{
    setPatientList(todaysAppointment)
  },[todaysAppointment])
  return (
    <>
        
        <PatientHeader />
        <div className='app-container container-xxl'>
              <div className="card">
                <div className="card-body">
                 
                  <PatientList patients={patientList}/>
                  <div className="d-flex justify-content-end">
                    <Pagination2 ></Pagination2>
                  </div>
                </div>
              </div>
        </div>
    </>
  )
}

export default PatientFiles